import React from 'react'
import PropTypes from 'prop-types'
import { CheckoutLayout as KitCheckoutLayout } from '@telus/koodo-ui-kit'
import StepTracker from '@apps/components/StepTracker'
import SessionCard from '@apps/components/SessionCard'
import OrderSummary from '@apps/components/OrderSummary'

/**
 * Thin app wrapper around the kit's `<CheckoutLayout />`. Fills the kit's
 * slots with prepaid-specific shared components (`SessionCard`, `StepTracker`,
 * `OrderSummary`) so pages just supply heading + form. Appends an anchor
 * div inside the form column that `FloatingCookieManager` portals its
 * "Manage Cookies" link into — keeping the link aligned to the right edge
 * of the form card rather than spanning the full page width.
 */
const CheckoutLayout = ({ heading, activeStepIndex, children }) => (
  <KitCheckoutLayout
    topSection={
      <>
        {heading}
        {activeStepIndex !== undefined && (
          <StepTracker activeStepIndex={activeStepIndex} noWrapper />
        )}
      </>
    }
    cardSession={<SessionCard />}
    cart={<OrderSummary />}
  >
    {children}
    <div
      data-component="payment-summary-cookie-anchor"
      data-cookie-link-variant="plain"
      className="mt-4 flex justify-end"
    />
  </KitCheckoutLayout>
)

CheckoutLayout.propTypes = {
  heading: PropTypes.node,
  activeStepIndex: PropTypes.number,
  children: PropTypes.node
}

export default CheckoutLayout
